import { useQuery } from "@tanstack/react-query";
import {
  getStateByCountryId,
  getStateByCountryIdAndAbbr,
} from "../services/state-service";
import {
  GetStatesResponse,
  State,
} from "../models/response/get-states-response";
import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { PER_PAGE } from "pages/admin-app/adminapp.constants";

interface Props {
  countryId: number;
  currentPage: number;
  searchQuery?: string;
}

interface GetStateByCountryIdAndAbbrProps {
  countryId: number;
  abbr: string;
}

export function useNAMStates({ countryId, currentPage, searchQuery }: Props) {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery<
    GetStatesResponse,
    ApiError
  >({
    queryKey: ["stateByCountryId", countryId, currentPage, searchQuery],
    
    queryFn: () =>
      getStateByCountryId({
        countryId,
        page: currentPage,
        perPage: PER_PAGE,
        searchQuery,
      }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data: data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
    isFetching,
  };
}

export function useStateByAbbr({
  countryId,
  abbr,
}: GetStateByCountryIdAndAbbrProps) {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery<
    State,
    ApiError
  >({
    queryKey: ["stateByAbbr", countryId, abbr],
    queryFn: () =>
      getStateByCountryIdAndAbbr({
        countryId,
        abbr,
      }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data: data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
    isFetching,
  };
}
